import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'

type StepCardProps = {
  className?: string
  title: string
  description: string
  imagePath: string
}

export function StepCard({
  className,
  title,
  description,
  imagePath,
}: StepCardProps) {
  return (
    <div
      className={clsx(
        'rounded border border-red-60 bg-red-5 flex space-x-2 p-3 items-center',
        className
      )}
    >
      <img
        src={assetUrl(imagePath)}
        alt=""
        width={64}
        height={64}
        className="flex-shrink-0"
      />
      <div className="space-y-1">
        <Text variant="heading-sm">{title}</Text>
        <Text variant="body-sm" color="critical">
          {description}
        </Text>
      </div>
    </div>
  )
}
